import React, { useEffect, useState } from "react";
import api from "../api";
import "./Workflow.css";

const WorkflowBubbles = ({ orderID, method }) => {
    const [status, setStatus] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    // New workflow based on timestamp fields in your SQL table
    const workflow = [
        "ordered",
        "paid",
        "supplierOrdered",
        "supplierReceived",
        method === "pickup" ? "readyForPickup" : "readyForDelivery",
        "fulfilled"
    ];

    useEffect(() => {
        const fetchStatus = async () => {
            if (!orderID) return;

            setLoading(true);
            setError("");

            try {
                const res = await api.get(`/orderStatus/${orderID}`);
                setStatus(res.data); // now a single object, not an array
            } catch (err) {
                console.error("Error fetching workflow status:", err);
                setError("Failed to load workflow.");
            } finally {
                setLoading(false);
            }
        };

        fetchStatus();
    }, [orderID]);

    if (loading) return <p>Loading workflow...</p>;
    if (error) return <p>{error}</p>;
    if (!status) return null;

    // Determine which steps are completed (timestamp != null)
    const completedSteps = workflow.filter(step => status[step] !== null);

    // Current active step = last completed step
    const currentIndex = completedSteps.length - 1;

    return (
        <div className="workflow-container">
            {workflow.map((step, index) => {
                let className = "bubble";

                if (index < currentIndex) {
                    className += " completed";
                } else if (index === currentIndex) {
                    className += " active";
                }

                return (
                    <div key={step} className="bubble-wrapper">
                        <div className={className}></div>
                        <div className="bubble-label">
                            {step
                                .replace(/([A-Z])/g, " $1")
                                .replace(/^./, (str) => str.toUpperCase())
                                .trim()}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default WorkflowBubbles;
